// extracted by mini-css-extract-plugin
export default {"heading":"TwoFactorAuth_heading__hjpT+","wrapper":"TwoFactorAuth_wrapper__+lcuK"};